export function toCapitalized(word) {
  if (!word) return '';
  return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
}

export function toUpperCaseWord(word) {
  if (!word) return '';
  return word?.toUpperCase();
}


export function toCapitalizedSentence(word) {
  if (!word) return '';
  return word
    ?.split('_') // split by underscore
    ?.map(w => w?.charAt(0)?.toUpperCase() + w?.slice(1)?.toLowerCase()) // capitalize each part
    ?.join(' '); // join with spaces
}

export function formatToUpperCase(word) {
  if (!word) return '';
  return word
    ?.replace(/_/g, ' ')       // replace underscores with spaces
    ?.trim()                   // remove extra spaces
    ?.toUpperCase();           // make everything uppercase
}






export const getModuleColor = (moduleName) => {
  const colorMap = {
    'Helmet': '#FF6B6B',
    'Vest': '#4ECDC4',
    'Boot': '#FFD93D',
    'MMHE': '#1A73E8',
    'Grouping': '#9D4EDD',
    'Person': '#00C49F',
    'Emergency_Exit': '#FF7C7C',
    'Machine_Guard': '#FFB74D',
    'No_Go_Area': '#2196F3',
    'Checker_Presence': '#F06292',
    'House_Keeping': '#26C6DA',
    'Supervisor_Presence': '#7E57C2',
    'Belt_Vest': '#66BB6A',
    'Forklift': '#FF8A65',
    'Medium_Forklift': '#BA68C8',
    'Hand_Forklift': '#4DB6AC',
    'Blue_Vest': '#42A5F5',
    'Red_Vest': '#E57373',
    'Intruder': '#EF5350',
    'Unathorise_Access': '#D32F2F',
    'Fire_Detection': '#FF5722',
    'PPE': '#81C784',
    'Bump_Cap': '#4FC3F7',
    'Head': '#9575CD',
    'Hands': '#AED581',
    'Eyes': '#64B5F6',
    'Gloves': '#FBC02D',
    'Goggles': '#03A9F4',
    'Coverall_Suit': '#F48FB1',
    'Hand_Rails': '#FFB300',
    'Floor_Spills': '#FF7043',
    'Face': '#7986CB',
    'Mask': '#4DD0E1',
    'Harness': '#00ACC1',
    'Work_Permit': '#8E24AA',
    'Vehicle': '#43A047',
    'Sitting_Idle': '#FFCA28',
    'Sleeves': '#8D6E63',
    'Glasses': '#29B6F6',
    'Arch_Suit': '#BA68C8',
    'Personal_Presence': '#26A69A',
    'Label_A_Big': '#EC407A',
    'Label_B_Small': '#AB47BC'
  };

  // default fallback color if no match found
  return colorMap[moduleName] || '#6F42C1';
};


export const getAreaIdsOfAreaOwner = () => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const areaIds = userData?.areas?.map(area => area.id);
  return areaIds;
}


export const checkAuthorizedClient = () => {
  const authorizedCliendIds = [2]
  const userData = JSON.parse(localStorage.getItem('userData'))?.client.id
  if (!authorizedCliendIds.includes(userData)) {
    return false
  }
  return true
}

export function extractDateTime(timestamp, { date = false, time = false }) {
  if (!timestamp) return null;

  const [rawDate, rest] = timestamp.split("T");
  const rawTime = rest ? rest.split("+")[0] : "";

  // agar time chahiye to AM/PM format me convert karo
  let formattedTime = "";
  if (time) {
    const [hourStr, minuteStr, secondStr] = rawTime.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = minuteStr;
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // 0 ko 12 banao
    formattedTime = `${hour}:${minute} ${ampm}`;
  }

  if (date && time) {
    return { date: rawDate, time: formattedTime };
  } else if (date) {
    return rawDate;
  } else if (time) {
    return formattedTime;
  }
  return null;
}

export const formatDate = (dateStr) => {
  console.log("dateStrdateStr",dateStr)
  if(!dateStr) return ''
  const [year, month, day] = dateStr?.split("-");
  return `${month}/${day}/${year}`;
};